import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "@/assets/js/models/helpers/JsonMapper";
import ECommerceSdkAccount from "@/assets/js/models/ECommerceSdk/ECommerceSdkAccount";
var _attributes = /*#__PURE__*/new WeakMap();
export default class SdkAccountOrder extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [SdkAccountOrder.id_attribute_name]: null,
      [SdkAccountOrder.order_id_attribute_name]: null,
      [SdkAccountOrder.sdk_account_id_attribute_name]: null,
      [SdkAccountOrder.sdk_account_attribute_name]: ECommerceSdkAccount,
      [SdkAccountOrder.status_attribute_name]: null,
      [SdkAccountOrder.status_message_attribute_name]: null,
      [SdkAccountOrder.custom_id_attribute_name]: null,
      [SdkAccountOrder.other_attribute_name]: null,
      [SdkAccountOrder.created_at_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getStatusAttributeName() {
    return this.status_attribute_name;
  }
  static getStatusMessageAttributeName() {
    return this.status_message_attribute_name;
  }
  static getSdkAccountAttributeName() {
    return this.sdk_account_attribute_name;
  }
  getStatusMessage() {
    return this.getAttribute(SdkAccountOrder.getStatusMessageAttributeName());
  }
  getSdkAccount() {
    return this.getAttribute(SdkAccountOrder.getSdkAccountAttributeName());
  }
  getStatus() {
    return this.getAttribute(SdkAccountOrder.getStatusAttributeName());
  }
  isSuccessful() {
    return this.getStatus() === SdkAccountOrder.SUCCESS_STATUS;
  }
}
_defineProperty(SdkAccountOrder, "SUCCESS_STATUS", 'success');
_defineProperty(SdkAccountOrder, "FAILED_STATUS", 'failed');
_defineProperty(SdkAccountOrder, "PENDING_STATUS", 'pending');
_defineProperty(SdkAccountOrder, "id_attribute_name", 'id');
_defineProperty(SdkAccountOrder, "order_id_attribute_name", 'order_id');
_defineProperty(SdkAccountOrder, "sdk_account_id_attribute_name", 'sdk_account_id');
_defineProperty(SdkAccountOrder, "sdk_account_attribute_name", 'sdk_account');
_defineProperty(SdkAccountOrder, "status_attribute_name", 'status');
_defineProperty(SdkAccountOrder, "status_message_attribute_name", 'status_message');
_defineProperty(SdkAccountOrder, "custom_id_attribute_name", 'custom_id');
_defineProperty(SdkAccountOrder, "other_attribute_name", 'other');
_defineProperty(SdkAccountOrder, "created_at_attribute_name", 'created_at');